import React, { useEffect, useState } from "react";
import { getAgreement } from "../../graphql/queries";
import { useParams } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { Typography, Button, Stack } from "@mui/material";
import { getUrl } from "aws-amplify/storage";
import { Download } from "lucide-react";

const PaymentDetail = () => {
  const params = useParams();
  const client = generateClient();
  const [payment, setPayment] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAgreement = async () => {
      try {
        setLoading(true);
        const res = await client.graphql({
          query: getAgreement,
          variables: { id: params.id },
        });

        if (res?.data?.getAgreement?.paymentReceiptFilePath) {
          const response = await getUrl({
            key: res?.data?.getAgreement?.paymentReceiptFilePath,
            options: { validateObjectExistence: true },
          });
          setPayment(response.url.href);
        }
      } catch (error) {
        console.error("Error fetching agreement details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgreement();
  }, [params.id, client]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = payment;
    link.setAttribute("download", "PaymentReceipt.jpg"); // File name for download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Payment Details
      </Typography>

      {/* Render the image if available */}
      {payment ? (
        <Stack
          sx={{ maxWidth: "300px" }}
          direction={"row"}
          alignItems={"flex-start"}
        >
          <img
            src={payment}
            alt="Payment Receipt"
            style={{ maxHeight: "400px", marginBottom: "16px" }}
          />
          <Button variant="contained" color="primary" onClick={handleDownload}>
            <Download />
          </Button>
        </Stack>
      ) : (
        <Typography variant="body1">Payment receipt not available.</Typography>
      )}
    </div>
  );
};

export default PaymentDetail;
